module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0012.0bcdf07b.jpg";